// extracted by mini-css-extract-plugin
module.exports = {"countBox":"CompanyCountsSection_countBox__qgNk1","container":"CompanyCountsSection_container__7MIeF"};